import React from 'react';
import history from './history';
import lang from './../languages/en';
import { dialogConfirm } from './dialog';
import { renderListShipment, renderListOrder, splitMessage, showWaringTransmitNotCompleted } from './helper';
import { alertError, dialogError } from './dialog';
import Storage from './Storage';
import { logout } from './../utils/login';
import { Modal } from 'antd';
import { logoutProcess as logoutProcessHelper } from './authHelper';

/**
 * logout process
 */
const logoutProcess = () => {
    logout(); // ajax call api logout
    Storage.clearAll(); // clear storage cache
    Modal.destroyAll();
}

const hanldeException = (data) => {
    let params
    if (data && data.data && data.data.code) {
        switch (data.data.code) {
            case 211112:
                alertError(lang.payment_term_invalid)
                return
            case 211140:
                alertError(lang.channel_order_existed)
                return
            case 211137:
                alertError(lang.item_code_dumplicate)
                return
            case 211135:
                alertError(lang.origin_wrong_format)
                return
            case 211115:
                alertError(lang.currency_wrong_format)
                return
            case 211139:
                alertError(lang.status_not_edit)
                return
            case 102002:
                alertError(lang.invalid_email)
                return;
            case 211143:
                if (history.location.pathname === '/orders') {
                    dialogError(lang.status_cancel_not_delete)
                    renderListOrder()
                } else {
                    alertError(lang.status_cancel_not_delete)
                }
                return
            case 211153:
                alertError(lang.name_in_alphabet)
                return
            case 211138:
                alertError(lang.order_has_delete, lang.order_has_delete_line2)
                history.push('/orders')
                return
            case 211144:
            case 311402:
                alertError(lang.order_not_existed)
                history.push('/orders')
                return
            case 311902:
                alertError(lang.shipment_not_exist)
                history.push('/shipments')
                return
            case 211165:
                alertError(lang.channel_code_existed)
                return
            case 313003:
                alertError(lang.wrong_format_password)
                return
            case 313004:
                alertError(lang.password_current_wrong)
                return
            case 218005:
                dialogError(lang.channel_is_not_correctly, lang.channel_is_not_correctly_line2)
                return
            case 218006:
                splitMessage(data.data.message, 3)
                return;
            case 311809:
                showWaringTransmitNotCompleted(data.data.message)
                return;
            case 311807:
                showWaringTransmitNotCompleted(data.data.message)
                return;
            case 102001:
                alertError(lang.email_empty)
                return;
            case 311806:
            case 218007:
            case 218008:
            case 311808:
                dialogError(data.data.message)
                return
            case 312510:
            case 10010:
                renderListShipment()
                dialogError(lang.transmit_fails)
                return
            case 212501:
                alertError(lang.amazon_seller_id_empty)
                return
            case 212502:
                alertError(lang.aws_auth_token_empty)
                return
            case 212503:
                alertError(lang.aws_access_key_id)
                return
            case 212504:
                alertError(lang.secret_key_empty)
                return
            case 212505:
                alertError(lang.marketplace_id_empty)
                return
            case 212506:
                alertError(lang.seller_not_verified, lang.seller_not_verified_line2)
                return
            case 10000:
                alertError(lang.error_common)
                return
            case 10002:
                alertError(lang.permission_denied)
                return
            case 10003:
                alertError(lang.no_input_data)
                return
            case 10006: // error another login
                alertError(lang.error_login_other_account, lang.login_again, logoutProcess(), logoutProcess());
                return
            case 311701:
                alertError(lang.order_date_mus_in_order)
                return
            case 218001:
                params = {
                    message: (
                        <div>
                            <h4>{lang.channel_not_configured}</h4>
                            <h4>{lang.verify_seller}</h4>
                        </div>
                    ),
                    type: 'error_eCommerce'
                }
                dialogConfirm(params)
                return
            case 218002:
                dialogError(lang.not_get_channel_infor)
                return
            case 218003:
                params = (
                    <div>
                        <h4>{lang.user_of_shop_current_in_process_import}</h4>
                    </div>
                )
                dialogError(params)
                return
            case 218004:
                dialogError(lang.amazon_marketplace_server_error)
                return
            case 211148:
                params = (
                    <div>
                        <h4>{lang.request_limit}</h4>
                        <h4>{lang.wait_a_few_min_and_try_again}</h4>
                    </div>
                )
                dialogError(params)
                return
            case 312002:
                dialogError(lang.package_not_exist)
                renderListShipment()
                return
            case 311804:
            case 210401:
            case 312508:
                renderListShipment()
                dialogError(lang.package_not_exist)
                return
            case 312003:
                renderListShipment()
                dialogError(lang.package_cannot_print)
                return
            case 311502:
                renderListOrder()
                dialogError(lang.order_do_not_exist)
                return
            case 212801:
                alertError(lang.invalid_file_type, lang.select_file_csv)
                return
            case 212802:
                alertError(lang.error_save_csv)
                return
            case 212803:
                alertError(lang.error_loaded_csv)
                return
            case 212804:
                alertError(lang.data_null_in_csv)
                return
            case 212805:
                alertError(lang.alphanumeric_characters_item_code_en_title)
                return
            case 213306:
                alertError(data.data.message)
                return
            case 212807:
                alertError(lang.error_message_duplicate_data)
                return
            case 212808:
                alertError(lang.csv_file_contains_dumplicate_sku)
                return
            case 212809:
                alertError(lang.error_when_synchronized_import_item_name)
                return
            case 212810:
                alertError(lang.could_not_get_updated_file)
                return
            case 212811:
                alertError(lang.no_file_selected, lang.select_file_item_master)
                return
            case 212812:
                alertError(lang.alphabet_chacracter_for_country_of_origin)
                return
            case 212901:
                alertError(lang.error_infor_item_name)
                return
            case 212902:
                alertError(lang.page_size_mus_not_negative)
                return
            case 212903:
                alertError(lang.page_must_not_negative)
                return
            case 213302:
                alertError(lang.item_code_null)
                return
            case 213303:
                alertError(lang.item_name_null)
                return
            case 213304:
                alertError(lang.sku_dumplicate)
                return
            case 213301:
            case 213001:
                alertError(lang.id_mus_not_be_nagative)
                return
            case 213305:
                alertError(lang.sku_null)
                return
            case 221103:
                alertError(lang.shipper_not_access)
                return;
            case 221501:
                alertError(lang.mapping_id_null)
                return;
            case 221503:
                alertError(lang.mapping_id_delete)
                return;
            case 221504:
                alertError(lang.file_content_empty)
                return;
            case 221505:
                alertError(lang.content_file_not_mapping)
                return;
            case 221507:
                alertError(lang.import_other_current_shipper)
                return;
            case 7002:
                Storage.remove('shipper_active')
                history.push('/switch-shipper')
                return;
            case 221502:
                alertError(lang.import_mapping_not_exist)
                return;
            case 221510:
                alertError(lang.file_format_not_correct)
                return;
            case 7003:
                alertError(lang.channel_not_exist)
                return;
            case 221511:
                alertError(lang.max_4000_lines_upload_file)
                return;
            case 311602:
                alertError(lang.package_has_delete)
                return;
            case 221604:
                alertError("Order information was just edited by other user")
                return;
            case 221605:
                alertError("Itemname current setting null")
                return;
            case 221606:
                alertError("ChangeItemOrder is Null")
                return;
            case 221607:
                alertError("UpdateItemNameOrderDetai is error")
                return;
            case 221608:
                alertError("CreateNewItemName is error")
                return;
            case 211161:
                alertError("Please enter valid data into all required fields and try again.")
                return;
            case 221609:
                alertError(lang.split_parent_order_null)
                return;
            case 221710:
                alertError(lang.split_order_data_is_null)
                return;
            case 221711:
                alertError(lang.split_order_cannot_delete)
                return;
            case 221712:
                alertError(lang.split_order_input_data_error)
                return;
            case 221713:
                alertError(lang.split_order_data_error)
                return;
            case 221714:
                alertError(lang.split_order_channelId_length_invalid)
                return;
            case 221715:
                alertError(lang.split_order_splited)
                return;
            case 221716:
                alertError(lang.split_order_cannot_delete_splited_order)
                return;
            case 221717:
                alertError(lang.reference_number_duplicated)
                return;
            case 311504:
                alertError(lang.shipment_ch_duplidated)
                return;
            case 311505:
                alertError(lang.address_information_invalid)
                return;
            case 320001:
                alertError(lang.export_mapping_not_found)
                return;
            case 320002:
                alertError(lang.shipment_data_changed)
                return;
            case 320003:
                alertError(lang.shipment_not_found)
                return;
            case 320004:
                alertError(lang.can_not_create_file)
                return;
            case 320005:
                alertError(data.data.message)
                return;
            case 311601:
                alertError(lang.package_id_null)
                return;
            case 312005: 
                alertError(lang.traking_number_is_duplicated)
                return;
            default:
                alertError(lang.error_common)
                return
        }
    }

    if (data && data.response && data.response.status) {
        switch (data.response.status) {
            case 401:
                if (!localStorage.getItem('access_token')) {
                    return;
                }
                if (typeof data.response === 'object' &&
                    typeof data.response.data === 'object' &&
                    data.response.data.message
                ) {
                    alertError(data.response.data.message, null, logoutProcessHelper());
                    return;
                }
                logoutProcessHelper();
                return;
            case 403:
                alertError(lang.permission_denied)
                return
            case 404:
                history.push('/404')
                return
            case 500:
                history.push('/500')
                return
            case 504:
                alertError(lang.timeout_import_order)
                return
            case 400:
                alertError(lang.error_common)
                return
            case 406: // error another login
                alertError(lang.error_login_other_account, lang.login_again, logoutProcess(), logoutProcess());
                return
            default:
                alertError(lang.error_common)
                return
        }
    }
    // error not response: 504
    //alertError(lang.error_common);
}
export default hanldeException



// WEBPACK FOOTER //
// ./src/services/handleException.js